// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Editor-only visual feedback for LockedText.js.
 * Scoped to .ck-editor__editable so it never affects the saved HTML
 * when it is rendered outside the editor (preview, PDF export, ...).
 */
.ck-editor__editable [data-locked="true"] {
  background-color: rgba(255, 0, 0, 0.3);
  border-radius: 2px;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/plugins/custom/lockedtext.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/*\n * Editor-only visual feedback for LockedText.js.\n * Scoped to .ck-editor__editable so it never affects the saved HTML\n * when it is rendered outside the editor (preview, PDF export, ...).\n */\n.ck-editor__editable [data-locked=\"true\"] {\n  background-color: rgba(255, 0, 0, 0.3);\n  border-radius: 2px;\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
